document.addEventListener('DOMContentLoaded', () => {
    initElektrarnaDetail();
});

function initElektrarnaDetail() {
    const el = document.querySelector('#updateElektrarnaDetailData');
    if (!el) {
        return;
    }

    // Na balance stránce řeší update userDevice.js přes updateDevicesData s appendBalanceData=true
    if (document.querySelector('#updateDevicesData')) {
        return;
    }

    const detail = new ElektrarnaDetail();
    detail.init();
}

class ElektrarnaDetail {

    constructor() {
        this.isProcessing = false;
    }

    init() {
        setInterval(() => {
            this.update();
        }, 1000);
    }

    update() {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        fetch(document.querySelector('#updateElektrarnaDetailData').value, {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        .then(r => r.json())
        .then(payload => {
            if (payload && payload.balanceData) {
                this.updateBalanceSection(payload.balanceData);
            }
        })
        .catch(error => {
            console.error('Chyba při aktualizaci dat zdroje energie:', error);
        })
        .finally(() => {
            this.isProcessing = false;
        });
    }

    updateBalanceSection(balanceData) {
        if (balanceData.lightnings) {
            balanceData.lightnings.forEach((lightning, index) => {
                const counter = index + 1;
                const objectWrapper = document.querySelector(`.balance-grid .balance-col-1 .icon-wrapper:nth-child(${counter})`);

                if (!objectWrapper) {
                    return;
                }

                const isBalanceMode = objectWrapper.classList.contains('icon-wrapper-balance');
                const isLightingMode = !isBalanceMode;

                if (isBalanceMode) {
                    const batteryImg = objectWrapper.querySelector('.img-wrapper-left .img-wrapper-cell:nth-child(2) img');
                    if (batteryImg) {
                        if (lightning.availableCapacityIcon === null || lightning.measuredFlowKw === null) {
                            batteryImg.src = '/dist/imgs/battery-small.jpg';
                        } else {
                            batteryImg.src = `/dist/imgs/battery-small-${lightning.availableCapacityIcon}.png?v2`;
                        }
                    }

                    const fveCell = objectWrapper.querySelector('.img-wrapper-left .img-wrapper-cell:nth-child(1)');
                    if (fveCell) {
                        const fveSpan = fveCell.querySelector('span');
                        const vKw = lightning.measuredFlowFveKw;
                        if (fveSpan) {
                            if (vKw === null || vKw === undefined) {
                                fveSpan.innerHTML = 'N/A';
                            } else {
                                const formatted = vKw.toFixed(2);
                                if (vKw === 0) {
                                    fveSpan.innerHTML = `<strong>${formatted} kW</strong>`;
                                } else {
                                    const cls = vKw > 0 ? 'text-success' : 'text-danger';
                                    fveSpan.innerHTML = `<strong class="${cls}">${formatted} kW</strong>`;
                                }
                            }
                        }
                        this.updateLineForCell(fveCell, lightning.measuredFlowFveKw, counter, 'fve');
                    }

                    const battCell = objectWrapper.querySelector('.img-wrapper-left .img-wrapper-cell:nth-child(2)');
                    if (battCell) {
                        const battSpan = battCell.querySelector('span');
                        const vKw = lightning.measuredFlowBatteryKw;
                        if (battSpan) {
                            if (vKw === null || vKw === undefined) {
                                battSpan.innerHTML = 'N/A';
                            } else {
                                const formatted = vKw.toFixed(2);
                                if (vKw === 0) {
                                    battSpan.innerHTML = `<strong>${formatted} kW</strong>`;
                                } else {
                                    const cls = vKw > 0 ? 'text-success' : 'text-danger';
                                    battSpan.innerHTML = `<strong class="${cls}">${formatted} kW</strong>`;
                                }
                            }
                        }
                        this.updateLineForCell(battCell, lightning.measuredFlowBatteryKw, counter, 'battery');
                    }

                    const houseCell = objectWrapper.querySelector('.img-wrapper-right .img-wrapper-cell');
                    if (houseCell) {
                        const houseSpan = houseCell.querySelector('span');
                        const vKw = lightning.measuredFlowHouseKw;
                        if (houseSpan) {
                            if (vKw === null || vKw === undefined) {
                                houseSpan.innerHTML = 'N/A';
                            } else {
                                const formatted = vKw.toFixed(2);
                                if (vKw === 0) {
                                    houseSpan.innerHTML = `<strong>${formatted} kW</strong>`;
                                } else {
                                    const cls = vKw > 0 ? 'text-success' : 'text-danger';
                                    houseSpan.innerHTML = `<strong class="${cls}">${formatted} kW</strong>`;
                                }
                            }
                        }
                    }

                    const allDescriptions = document.querySelectorAll('.balance-grid .balance-col-1 .description');
                    const description = allDescriptions[index];
                    if (description) {
                        const formatValueKw = (valueKw) => {
                            if (valueKw === null || valueKw === undefined) {
                                return '<strong>N/A</strong>';
                            }
                            const formatted = valueKw.toFixed(2);
                            if (valueKw === 0) {
                                return `<strong>${formatted} kW</strong>`;
                            }
                            const cls = valueKw > 0 ? 'text-success' : 'text-danger';
                            return `<strong class="${cls}">${formatted} kW</strong>`;
                        };

                        let fveState = '';
                        if (lightning.measuredFlowFveKw !== null && lightning.measuredFlowFveKw !== undefined) {
                            fveState = lightning.measuredFlowFveKw === 0 ? '(čeká na slunce)' : '(vyrábí el. energii)';
                        }

                        let batteryState = '';
                        if (lightning.measuredFlowBatteryKw !== null && lightning.measuredFlowBatteryKw !== undefined) {
                            if (lightning.measuredFlowBatteryKw > 0) {
                                batteryState = '(dodává energii)';
                            } else if (lightning.measuredFlowBatteryKw < 0) {
                                batteryState = '(nabíjí se)';
                            } else {
                                batteryState = '(čeká na příkaz)';
                            }
                        }

                        let capacityPercent = 'N/A';
                        let capacityTotal = '';
                        if (lightning.availableCapacity !== null && lightning.capacity !== null) {
                            capacityPercent = '<strong>' + lightning.availableCapacity + '%</strong>';
                            capacityTotal = 'z celkových <strong>' + lightning.capacity + ' kWh</strong>';
                        }

                        description.innerHTML = `
                            <strong>${lightning.username}</strong>
                            <table class="table table-sm table-bordered table-striped table-hover mt-2 mb-0" style="font-size: 0.95em;">
                                <tbody>
                                    <tr>
                                        <td>FVE aktuální stav</td>
                                        <td class="text-end">${formatValueKw(lightning.measuredFlowFveKw)}</td>
                                        <td>${fveState.replace(/[()]/g, '')}</td>
                                    </tr>
                                    <tr>
                                        <td>FVE instalovaný výkon</td>
                                        <td class="text-end">${lightning.fveInstalledKwp !== null && lightning.fveInstalledKwp !== undefined ? `<strong>${Number(lightning.fveInstalledKwp).toFixed(2)} kWp</strong>` : '<strong>N/A</strong>'}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>FVE rezervovaný výkon</td>
                                        <td class="text-end">${lightning.fveReservedPercent !== null && lightning.fveReservedPercent !== undefined ? `<strong>${lightning.fveReservedPercent}%</strong>` : '<strong>N/A</strong>'}${lightning.fveReservedKwp !== null && lightning.fveReservedKwp !== undefined ? ` | <strong>${Number(lightning.fveReservedKwp).toFixed(2)} kW</strong>` : ''}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>FVE nastavený limit</td>
                                        <td class="text-end">${lightning.fveLimitKwp !== null && lightning.fveLimitKwp !== undefined ? `<strong>${Number(lightning.fveLimitKwp).toFixed(2)} kW</strong>` : '<strong>N/A</strong>'}</td>
                                        <td></td>
                                    </tr>
                                    <tr class="table-group-spacer"><td colspan="3"></td></tr>
                                </tbody>
                                <tbody class="border-top-thick">
                                    <tr>
                                        <td>Aktuální stav baterie</td>
                                        <td class="text-end">${formatValueKw(lightning.measuredFlowBatteryKw)}</td>
                                        <td>${batteryState.replace(/[()]/g, '')}</td>
                                    </tr>
                                    <tr>
                                        <td>Kapacita baterie</td>
                                        <td class="text-end">${capacityPercent}</td>
                                        <td>${capacityTotal}</td>
                                    </tr>
                                    <tr>
                                        <td>SOC baterie ongrid</td>
                                        <td class="text-end">${lightning.socOngrid !== null && lightning.socOngrid !== undefined ? `<strong>${lightning.socOngrid}%</strong>` : '<strong>N/A</strong>'}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>SOC baterie offgrid</td>
                                        <td class="text-end">${lightning.socOffgrid !== null && lightning.socOffgrid !== undefined ? `<strong>${lightning.socOffgrid}%</strong>` : '<strong>N/A</strong>'}</td>
                                        <td></td>
                                    </tr>
                                    <tr class="table-group-spacer"><td colspan="3"></td></tr>
                                </tbody>
                                <tbody class="border-top-thick">
                                    <tr>
                                        <td>Vnitřní spotřeba objektu</td>
                                        <td class="text-end">${formatValueKw(lightning.measuredFlowHouseKw)}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><strong>Průtok na patě objektu</strong></td>
                                        <td class="text-end">${formatValueKw(lightning.measuredFlowKw)}</td>
                                        <td>${lightning.measuredFlowKw > 0 ? 'přetok do sítě' : lightning.measuredFlowKw < 0 ? 'odběr ze sítě' : ''}</td>
                                    </tr>
                                </tbody>
                            </table>
                        `;
                    }

                    this.updateHorizontalLine(objectWrapper, lightning.measuredFlowKw, lightning.measuredFlowKw, counter, true, true);
                }

                if (isLightingMode) {
                    if (lightning.measuredFlowKw !== null && lightning.availableCapacityIcon !== null) {
                        const batteryImg = objectWrapper.querySelector('.img-wrapper-double img:nth-child(2)');
                        if (batteryImg) {
                            batteryImg.src = `/dist/imgs/battery-small-${lightning.availableCapacityIcon}.png?v2`;
                        }
                    }

                    const infoText = objectWrapper.querySelector('span');
                    if (infoText) {
                        let capacityText = 'N/A';
                        if (lightning.measuredFlowKw !== null && lightning.availableCapacity !== null) {
                            capacityText = `${lightning.availableCapacity} % z ${lightning.capacity} kWh`;
                        }

                        const flowKw = lightning.measuredFlowKw;
                        let flowText = 'N/A';
                        let flowClass = '';
                        if (flowKw !== null && flowKw !== undefined) {
                            flowText = flowKw.toFixed(2) + ' kW';
                            if (flowKw !== 0) {
                                flowClass = flowKw > 0 ? 'text-success' : 'text-danger';
                            }
                        }

                        infoText.innerHTML = `
                            <strong>${lightning.username}</strong><br>
                            Dostupná kapacita: ${capacityText} <br>
                            Povolený výkon: ${lightning.maxOutput} kW <br>
                            Měřený průtok: <strong class="${flowClass}">${flowText}</strong>
                        `;
                    }

                    this.updateHorizontalLine(objectWrapper, lightning.measuredFlowKw, lightning.measuredFlowKw, counter, false);
                }
            });
        }

        if (balanceData.lamps) {
            balanceData.lamps.forEach((lamp, index) => {
                const counter = index + 1;

                let lampWrapper = document.querySelector(`.balance-grid .balance-col-5 .icon-wrapper.icon-wrapper-output:nth-child(${counter})`);
                if (!lampWrapper) {
                    lampWrapper = document.querySelector(`.balance-grid .balance-col-5 .icon-wrapper.icon-wrapper-lamps:nth-child(${counter})`);
                }

                if (lampWrapper) {
                    const infoText = lampWrapper.querySelector('span');
                    if (infoText) {
                        const isOutputMode = lampWrapper.classList.contains('icon-wrapper-output');

                        if (isOutputMode) {
                            infoText.innerHTML = `
                                <strong>${lamp.username}</strong><br>
                                ${this.getPowerHtmlLighting(lamp.sumKw)}
                            `;
                        } else {
                            infoText.innerHTML = `
                                <strong>VO ${lamp.username}</strong><br>
                                ${this.getPowerHtmlLighting(lamp.sumKw)}
                            `;
                        }
                    }

                    this.updateLampLine(lampWrapper, lamp.sumKw, counter);
                }
            });
        }
    }

    updateHorizontalLine(objectWrapper, measuredFlowW, measuredFlowKw, counter, includeTextSpan, isBalanceMode = false) {
        let isVertical = false;
        let lineWrapper;
        if (isBalanceMode) {
            lineWrapper = objectWrapper.querySelector(`.line-wrapper-flow-kw`);
        } else {
            lineWrapper = objectWrapper.querySelector(`.line-wrapper-horizontal, .line-wrapper:not(.line-wrapper-vertical)`);
        }
        if (lineWrapper && lineWrapper.classList.contains('line-wrapper-vertical')) {
            isVertical = true;
        }

        if (measuredFlowW !== null) {
            if (!lineWrapper) {
                lineWrapper = document.createElement('div');
                if (isBalanceMode) {
                    lineWrapper.className = `line-wrapper line-wrapper-flow-kw line-wrapper-${counter}${includeTextSpan ? ' line-wrapper-horizontal' : ''}`;
                } else {
                    lineWrapper.className = `line-wrapper line-wrapper-horizontal line-wrapper-${counter}`;
                }

                const animatedLine = document.createElement('div');
                animatedLine.className = measuredFlowW !== 0
                    ? `animated-line line-${measuredFlowW > 0 ? 'green' : 'red'}`
                    : 'animated-line';

                if (measuredFlowW !== 0) {
                    const lineDot = document.createElement('div');
                    lineDot.className = `line-dot ${measuredFlowW < 0 ? 'line-dot-revert' : ''}`;
                    animatedLine.appendChild(lineDot);
                }

                lineWrapper.appendChild(animatedLine);

                if (includeTextSpan && measuredFlowKw !== null && measuredFlowKw !== undefined) {
                    const textSpan = document.createElement('span');
                    const formatted = measuredFlowKw.toFixed(2);
                    const flowClass = measuredFlowKw !== 0
                        ? (measuredFlowKw > 0 ? 'text-success' : 'text-danger')
                        : '';
                    textSpan.innerHTML = `<strong class="${flowClass}">${formatted} kW</strong>`;
                    lineWrapper.appendChild(textSpan);
                }

                objectWrapper.appendChild(lineWrapper);
            } else {
                const animatedLine = lineWrapper.querySelector('.animated-line');
                if (animatedLine) {
                    animatedLine.className = measuredFlowW !== 0
                        ? `animated-line line-${measuredFlowW > 0 ? 'green' : 'red'}`
                        : 'animated-line';

                    let lineDot = animatedLine.querySelector('.line-dot');

                    if (measuredFlowW !== 0) {
                        if (!lineDot) {
                            lineDot = document.createElement('div');
                            animatedLine.appendChild(lineDot);
                        }
                        lineDot.className = `line-dot ${measuredFlowW < 0 ? 'line-dot-revert' : ''}`;
                    } else {
                        if (lineDot) {
                            lineDot.remove();
                        }
                    }
                }

                if (includeTextSpan && measuredFlowKw !== null && measuredFlowKw !== undefined) {
                    const innerSpan = lineWrapper.querySelector('span > strong');
                    const formatted = measuredFlowKw.toFixed(2);
                    const flowClass = measuredFlowKw !== 0
                        ? (measuredFlowKw > 0 ? 'text-success' : 'text-danger')
                        : '';
                    if (innerSpan) {
                        innerSpan.className = flowClass;
                        innerSpan.textContent = `${formatted} kW`;
                    } else {
                        const textSpan = document.createElement('span');
                        textSpan.innerHTML = `<strong class="${flowClass}">${formatted} kW</strong>`;
                        lineWrapper.appendChild(textSpan);
                    }
                }
            }
        }
    }

    updateLampLine(lampWrapper, sum, counter) {
        let lineWrapper = lampWrapper.querySelector('.line-wrapper');

        if (sum !== null) {
            const hasFlow = sum !== 0;
            const isPositive = sum > 0;
            const lineColor = isPositive ? 'line-green' : 'line-red';

            if (!lineWrapper) {
                const newLineWrapper = document.createElement('div');
                newLineWrapper.className = `line-wrapper line-wrapper-${counter}`;

                const animatedLine = document.createElement('div');
                animatedLine.className = hasFlow ? `animated-line ${lineColor} line-mar-top` : 'animated-line line-mar-top';

                if (hasFlow) {
                    const lineDot = document.createElement('div');
                    lineDot.className = `line-dot${isPositive ? ' line-dot-revert' : ''}`;
                    animatedLine.appendChild(lineDot);
                }

                newLineWrapper.appendChild(animatedLine);
                lampWrapper.appendChild(newLineWrapper);
            } else {
                const animatedLine = lineWrapper.querySelector('.animated-line');
                if (animatedLine) {
                    animatedLine.className = hasFlow ? `animated-line ${lineColor} line-mar-top` : 'animated-line line-mar-top';

                    let lineDot = animatedLine.querySelector('.line-dot');
                    if (hasFlow) {
                        if (!lineDot) {
                            lineDot = document.createElement('div');
                            animatedLine.appendChild(lineDot);
                        }
                        lineDot.className = `line-dot${isPositive ? ' line-dot-revert' : ''}`;
                    } else {
                        if (lineDot) {
                            lineDot.remove();
                        }
                    }
                }
            }
        } else if (lineWrapper) {
            lineWrapper.remove();
        }
    }

    updateLineForCell(cell, value, counter, type) {
        let lineWrapper = cell.querySelector('.line-wrapper-vertical');

        if (value !== null) {
            if (!lineWrapper) {
                lineWrapper = document.createElement('div');
                lineWrapper.className = `line-wrapper line-wrapper-vertical line-wrapper-${counter}`;

                const animatedLine = document.createElement('div');
                animatedLine.className = value !== 0
                    ? `animated-line line-${value > 0 ? 'green' : 'red'}`
                    : 'animated-line';

                if (value !== 0) {
                    const lineDot = document.createElement('div');
                    lineDot.className = `line-dot ${value < 0 ? 'line-dot-revert' : ''}`;
                    animatedLine.appendChild(lineDot);
                }

                lineWrapper.appendChild(animatedLine);
                cell.appendChild(lineWrapper);
            } else {
                const animatedLine = lineWrapper.querySelector('.animated-line');
                if (animatedLine) {
                    animatedLine.className = value !== 0
                        ? `animated-line line-${value > 0 ? 'green' : 'red'}`
                        : 'animated-line';

                    let lineDot = animatedLine.querySelector('.line-dot');

                    if (value !== 0) {
                        if (!lineDot) {
                            lineDot = document.createElement('div');
                            animatedLine.appendChild(lineDot);
                        }
                        lineDot.className = `line-dot ${value < 0 ? 'line-dot-revert' : ''}`;
                    } else {
                        if (lineDot) {
                            lineDot.remove();
                        }
                    }
                }
            }
        }
    }

    getPowerHtmlLighting(kwValue, bold = true) {
        if (kwValue === null || kwValue === undefined) {
            if (bold) {
                return "<strong>N/A</strong>";
            }
            return 'N/A';
        }

        const formatted = kwValue.toFixed(2);
        let html = formatted + ' kW';
        if (bold) {
            html = "<strong>" + html + "</strong>";
        }

        if (kwValue === 0) {
            html = "<span>" + html + "</span>";
        } else if (kwValue > 0) {
            html = "<span class='text-success'>" + html + "</span>";
        } else {
            html = "<span class='text-danger'>" + html + "</span>";
        }

        return html;
    }
}
